export default __webpack_public_path__ + "static/media/bank_bca.7a04fa85.svg";